/**
 * Cross-package tuning constants. Pinned per the lane plan; agents on other
 * lanes must import these rather than redeclaring magic numbers locally.
 */
/** Colyseus listen port for the lobby + arena server. */
export const LOBBY_PORT = 2567;
/** Authoritative tick rate for the arena room, in Hz. */
export const ARENA_TICK_HZ = 20;
/** Authoritative tick rate for the lobby room, in Hz. */
export const LOBBY_TICK_HZ = 30;
/** Length of a Coin Arena match in seconds. */
export const MATCH_SECONDS = 60;
/** Max concurrent players per arena match. */
export const ARENA_MAX_PLAYERS = 8;
/** Number of coins spawned at the start of an arena match. */
export const ARENA_COIN_COUNT = 30;
/** Max retained chat lines in lobby chat ring buffer. */
export const CHAT_HISTORY_CAP = 100;
/**
 * Curated player-skin palette. Server rejects any colorHex not in this list.
 * Closed set instead of a free hex picker so a griefer can't pick #000 to vanish
 * into shadow or #fff to wash out against the warm-stone walls. Order is also
 * the deterministic-default index space — hash pubkey/sessionId mod length.
 */
export const PLAYER_COLOR_PALETTE = [
    "#e54545", // crimson
    "#f59f00", // amber
    "#9ab036", // olive
    "#0ea5a4", // teal
    "#5b8def", // steel
    "#9966e0", // violet
    "#ed7a9b", // rose
    "#cfa66b", // sand
];
/**
 * Holder-exclusive skins — one per base color. These render with a metallic +
 * emissive "finish" (see {@link HOLDER_FINISH}) so they visibly shimmer/glow,
 * a flex that pairs with the ✦ holder badge. The base palette stays open to
 * everyone; only verified token holders can select these (server-enforced in
 * the `color:set` handler). Jewel/metal hues kept distinct from the base set.
 */
export const HOLDER_COLOR_PALETTE = [
    "#ffd54a", // gold
    "#d8dde6", // platinum
    "#2fe6a0", // emerald
    "#ff4d6d", // ruby
    "#4d7cff", // sapphire
    "#b06cff", // amethyst
    "#ff9a8b", // rose gold
    "#2fe0e6", // chrome cyan
];
/**
 * Material parameters for the holder "special finish" — applied to the avatar
 * capsule when its color is a {@link HOLDER_COLOR_PALETTE} entry. Shared so the
 * local capsule + remote avatars + the picker preview render identically.
 */
export const HOLDER_FINISH = {
    metalness: 0.9,
    roughness: 0.22,
    emissiveIntensity: 0.38,
};
/** True when `hex` (case-insensitive) is a holder-exclusive finish color. */
export function isHolderColor(hex) {
    if (!hex)
        return false;
    return HOLDER_COLOR_PALETTE.includes(hex.toLowerCase());
}
/** True when `hex` is any valid palette color (base OR holder), case-insensitive. */
export function isPaletteColor(hex) {
    if (!hex)
        return false;
    const lower = hex.toLowerCase();
    return PLAYER_COLOR_PALETTE.includes(lower) || HOLDER_COLOR_PALETTE.includes(lower);
}
//# sourceMappingURL=constants.js.map